export function createNoPersister(idbValidKey = "reactQuery") {
    return {
        persistClient: async (client) => {
        },
        restoreClient: async () => {
            return;
        },
        removeClient: async () => {
        }
    };
}
